/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumOkKreis: {
    name: 'big-medium-ok-kreis';
    data: string;
} = {
    name: 'big-medium-ok-kreis',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M120.11 40a5 5 0 1 0-9.19 4 51 51 0 1 1-22.33-24.69 5 5 0 1 0 4.82-8.76A60.92 60.92 0 1 0 120.11 40"/><path d="M35.12 68.1a5 5 0 1 0-6.24 7.8l16.77 13.43a8.94 8.94 0 0 0 5.6 2 9 9 0 0 0 7.12-3.46l50.45-59.61a5 5 0 0 0-7.64-6.46l-50 59.14z"/></svg>`,
};
